import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/seo')({
  component: SeoLayout,
});

function SeoLayout() {
  return <Outlet />;
}
